type UnknownArrayOrObject = unknown[] | Record<string, unknown>;

export const dirtyValues = (
  dirtyFields: UnknownArrayOrObject | boolean,
  allValues: UnknownArrayOrObject,
): UnknownArrayOrObject => {
  // NOTE: Recursive function.
  // If *any* item in an array was modified, the entire array must be submitted, because there's no
  // way to indicate "placeholders" for unchanged elements. `dirtyFields` is `true` for leaves.
  if (dirtyFields === true || Array.isArray(dirtyFields)) {
    return allValues;
  }

  return Object.fromEntries(
    // @ts-expect-error - Element implicitly has an 'any' type. Errors with both dirtyFields[key] and allValues[key]
    Object.keys(dirtyFields).map((key) => [key, dirtyValues(dirtyFields[key], allValues[key])]),
  );
};

export const acceptableImageType = (type: string): boolean => {
  return ['image/png', 'image/jpeg', 'image/svg+xml'].find((findType) => {
    return findType === type;
  })
    ? true
    : false;
};

export const imageTypeMessage = 'Please choose a JPG, PNG, or SVG image';
